export namespace EventEmitter {
  export enum Events {
    OPEN_FILM_PAGE = 'openFilmPage',
    PLAYER_READY = 'playerReady',
    EXIT_FULLSCREEN = 'exitFullscreen',
    DETAIL_SCROLLED = 'detailScrolled',
    DATA_LOADED = 'dataLoaded',
    PLAYER_STICKY_CHANGE = 'PlayerStickyChange',
    IOS_FULLSCREEN_CHANGE = 'iosFullscreenChange',
    DETAIL_PAGE_OFFSET_CALCULATED = 'detailPageOffsetCalculated',
  }
}
